import { StyleSheet } from 'react-native';
import Theme, { fontStyles } from 'Theme';
import { Device } from 'DeviceUtils';
import dialogCommon from 'Theme/DialogCommon.jss';
import { title } from 'process';

const baseStyles = {
    backgroundContainer: {
        flex: 1,
        backgroundColor: 'black',
        justifyContent: 'center'
    },
    contentContainer: {
        width: Device.isPhone ? '80%' : '30%',
        backgroundColor: 'black',
        // justifyContent: 'center',
        alignContent: 'center',
        alignItems: 'center',
        alignSelf: 'center'
    },
    title: {
        ...fontStyles.title,
        color: 'white'
    },
    hr: {
        marginVertical: 20,
        borderBottomColor: 'white',
        width: '100%'
    },
    content: {
        ...fontStyles.subtitle,
        color: 'white',
        marginBottom: 20,
        textAlign: 'center'
    }
};

const landscapeStyles = StyleSheet.create({
    ...baseStyles
});

export { landscapeStyles };
export default StyleSheet.create(baseStyles);
